import './LeftBar.scss'
import { useDispatch, useSelector } from 'react-redux'
import { colspanMenu, colspanNotification } from 'store/actionReducers/MenuStore';
import iconMenu from '../../assets/images/Common/icon-menu.png'
import { BellOutlined } from '@ant-design/icons';

export default function LeftBar() {
  const dispatch = useDispatch();
  const MenuStore = useSelector((state: any) => state?.MenuStore);

  const handleShowMenu = () => {
    dispatch(colspanMenu())
  }

  const handleShowNotification = () => {
    dispatch(colspanNotification())
  }

  return (
    <>
      <div className='sjsjwttctx'>
        <div className='zztuucmeou'>
          <div className='edQzidjIpY'>{MenuStore?.menuActive?.nameActive}</div>
        </div>
        <div className='boiwzqtkwj'></div>
        <div className='boiwzqtkwj'></div>
        <div className='boiwzqtkwj'></div>
        <div className='JbkpDkPazF'>
          <div className='pjexeuktkf'>
            <div className={`yqccdnezsw ydbnjqeezf ${MenuStore?.showNotification ? 'JMylYBRWxI' : ''}`}>
              <BellOutlined className='RsnLzyqrlY' onClick={() => handleShowNotification()} />
            </div>
          </div>
          <div className='iqboiubuyb'>
            <div className='ckkisfjbwl' onClick={() => handleShowMenu()}>
              <img src={iconMenu} alt="" className='AAPQhcbMKQ' />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}